export enum ClipIconSize {
  small = 20,
  mediumSmall = 24,
  medium = 36,
  large = 48,
}
